<template>
  <div class="select-lang" :class="{ selected: isSelectLang }" @click="isSelectLang = !isSelectLang">
    <i class="icon icon-earth"></i>
    <span>{{ activeWebsite }} - {{ activelanguage }}</span>
    <i class="icon icon-down"></i>
    <!-- 下拉弹窗 -->
    <div class="select-list" v-if="isSelectLang">
      <ul>
        <li v-for="item in websiteList" :key="item.domainUrl" class="ub" >
          <div class="country" @click="changeWebsite(item.domainUrl)">{{ item.websiteName }}</div>
          <div class="ub-f1 lang">
            <p v-for="lang in item.langList" :key="lang.localeCode" @click="changeLanguage(item.domainUrl, lang)">{{ lang.localeName }}</p>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import apis from '@/utils/apis';
import { setLocale } from '@/locales';

export default {
  data() {
    return {
      isSelectLang: false,
      websiteList: [],
      langType: [],
      langTypeName: {},
      activeWebsite: '',
      activelanguage: '',
      languageCode: '',
      urlCode: '',
    };
  },
  mounted() {
    document.addEventListener('click', this.isBlur);
    this.getDictionaryLangLogin();
  },
  beforeDestroy: function () {
    window.removeEventListener('click', this.isBlur);
  },
  methods: {
    // 失焦收起语种选择
    isBlur: function (e) {
      if (!this.$el.contains(e.target)) {
        this.isSelectLang = false;
      }
    },
    // 获取站点和语言
    getDictionaryLangLogin: function () {
      this.$getJSON(apis.DictionaryLangLogin, {
        websiteType: 1,
        websiteEnv: this.websiteEnv, // 1-正式，2-测试
        domainUrl: window.location.origin,
      }).then((res) => {
        this.websiteList = res.data.websiteList;
        this.langType = res.data.langType;
        const website = res.data.website || { websiteName: this.$t('login_select_lang.wei_pei_zhi_zhan'), defaultLocale: 'CN' };
        this.activeWebsite = website.websiteName;
        const langCode = Cookies.get('langCode') || 'CN';
        const langTypeValueName = this.$listTransObject(this.langType, 'value', 'name');
        this.activelanguage = langTypeValueName[langCode];
        Cookies.set('mapType', website.mapType || '', { path: '/' }); // 记录地图类型
        Cookies.set('mapRegion', website.mapRegion || '', { path: '/' }); // 记录地图区域
        Cookies.set('siteCode', website.websiteCode || '', { path: '/' }); // 记录站点Code
        this.$emit('giveLanguage', langCode);
      });
    },
    // 切换站点
    changeWebsite: function (value) {
      this.isSelectLang = false;
      this.jumpOutside(`${value}${this.$route.path}`);
    },
    // 切换语言
    changeLanguage(domainUrl, lang) {
      this.isSelectLang = false;
      setLocale(lang.localeCode);
      this.jumpOutside(`${domainUrl}${this.$route.path}`);
    },
  },
};
</script>

<style lang="scss">
.select-lang {
  width: 180px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 6px 8px 6px 12px;
  color: #ffffff;
  font-size: 14px;
  line-height: 18px;
  vertical-align: top;
  position: relative;
  cursor: pointer;
  .icon-earth {
    float: left;
    color: #ffffff;
    font-size: 14px;
    margin-right: 4px;
  }
  .icon-down {
    float: right;
    color: #ffffff;
    font-size: 12px;
  }
  &.selected {
    background: rgba(238, 240, 245, 1);
    color: #5d859e;
    .icon-earth {
      color: #5d859e;
    }
    .icon-down {
      color: #000000;
    }
  }
}
.select-list {
  position: absolute;
  left: -1px;
  top: 31px;
  z-index: 8;
  width: 180px;
  padding: 0 16px;
  background-color: #ffffff;
  ul li {
    padding: 10px 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
  .country {
    width: 90px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
    line-height: 32px;
  }
  .lang {
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
    line-height: 32px;
    cursor: pointer;
  }
}
</style>
